/* eslint-disable linebreak-style */
import { createContext } from 'react';

const DocumentAuthorContext = createContext({});
export default DocumentAuthorContext;